import React from 'react'
import SubHeading from './SubHeading'
import Card from './Card'


function Project(props) {
    const webdev = [
        {
            "title": "Resume Builder",
            "description": "I developed a dynamic resume builder using a combination of HTML, CSS, JavaScript, and React. This project allows users to create professional resumes by filling out a form and generating a customized resume template. I created a user-friendly interface with validation checks for input fields. The integration of React provided a seamless and efficient rendering of components, allowing users to preview and customize their resumes in real-time.",
            "urlToImage": "https://drive.google.com/uc?id=1qC0BppKt60V3qXkSE4sL2BcJwqEW1XGx",
            "date": "2 Months Ago",
            "link": null
        },
        {
            "title": "Temp. Converter",
            "description": "I developed a temperature converter using HTML, CSS, and JavaScript. This project allows users to convert temperatures between Celsius, Fahrenheit, and Kelvin scales. The user interface provides input fields for entering the temperature value and dropdown menus to select the desired conversion units. The interface dynamically updates the converted temperature as the user inputs values or selects different units.",
            "urlToImage": "https://drive.google.com/uc?id=12VY4PBvcjN1yyADKm_J_qYEnVR8GV55a",
            "date": "2 Months Ago",
            "link": "https://scammerpatil.github.io/Temperature-Converter/"
        },
        {
            "title": "To-Do List",
            "description": "I created a dynamic TO-DO list using HTML, CSS, and JavaScript. This project allows users to create and manage their tasks in an organized manner. The user interface provides an input field to add new tasks and a list to display the existing tasks. The TO-DO list also features local storage integration, enabling users to persist their tasks even after closing the browser. The design is clean and user-friendly, making it easy to navigate and interact with the tasks.",
            "urlToImage": "https://drive.google.com/uc?id=1qX8_R28vaLR9QObA71JTGSOTLnXGxCFn",
            "date": "2 Months Ago",
            "link": null
        },
        {
            "title": "Landing Page",
            "description": "I designed a captivating landing page for ExpressVPN using HTML, CSS, and JavaScript. The landing page highlights the key selling points of ExpressVPN, such as enhanced online security, anonymous browsing, and access to geo-restricted content. The design is responsive and optimized for various screen sizes, ensuring a seamless experience across devices.",
            "urlToImage": "https://drive.google.com/uc?id=1ItYD--od1b_qTLSeUVRJtZiMOp9mWN-r",
            "date": "2 Months Ago",
            "link": "https://scammerpatil.github.io/landing-page/"
        },
        {
            "title": "Spotify Clone",
            "description": "I developed a Spotify clone using HTML, CSS, and JavaScript. This project replicates the core features and user interface of the popular music streaming platform, allowing users to search for and listen to their favorite songs and artists. I utilized APIs to retrieve music data and integrated audio streaming capabilities to enable users to listen to songs directly within the application.",
            "urlToImage": "https://storage.googleapis.com/pr-newsroom-wp/1/2018/11/folder_920_201707260845-1.png",
            "date": "2 Months Ago",
            "link": null
        },
        {
            "title": "Weather App",
            "description": "I developed a weather app using HTML, CSS, and JavaScript. This project allows users to get real-time weather information for a specific location. The user interface provides an input field for users to enter the desired location, and upon submission, the app fetches the weather data and displays it, including temperature, weather conditions, humidity, and wind speed.",
            "urlToImage": "https://drive.google.com/uc?id=1hOcxuVtcSnn3tVOJWH-MrlyR4cZsyK9v",
            "date": "2 Months Ago",
            "link": null
        },
        {
            "title": "Calculator",
            "description": "I developed a calculator using HTML, CSS, and JavaScript. This project provides a user-friendly interface for performing basic mathematical operations. Leveraging HTML's structure, CSS's styling capabilities, and JavaScript's event handling, I implemented the functionality to handle arithmetic calculations such as addition, subtraction, multiplication, and division.",
            "urlToImage": "https://drive.google.com/uc?id=1MRAXo8Jxny7Eyrz2OJKVKMtgSEz9JBcH",
            "date": "2 Months Ago",
            "link": "https://scammerpatil.github.io/Calculator/"
        },
        {
            "title": "Age Calculator",
            "description": "I developed an age calculator using HTML, CSS, and JavaScript. This project allows users to calculate their age based on their date of birth. The user interface provides input fields for entering the date, month, and year, and upon submission, the calculator determines the age and displays it.",
            "urlToImage": "https://calculator-online.net/img/og-img/age-calculator.png",
            "date": "2 Months Ago",
            "link": null
        },
        {
            "title": "Rock Paper Scissors",
            "description": "I developed a rock-paper-scissors game using HTML, CSS, and JavaScript. This project allows users to play the classic game against the computer. The user interface provides buttons for the player to choose between rock, paper, or scissors, and upon selection, the computer generates a random choice. The game determines the winner based on the rules of rock-paper-scissors, and the result is displayed on the screen.",
            "urlToImage": "https://drive.google.com/uc?id=1mBkZkD6J7KEMkG_DJm4pS9keaJaRkULa",
            "date": "2 Months Ago",
            "link": null
        }
    ]
    const javadev = [
        {
            "title": "Resume Builder",
            "description": "The Java-based Resume Builder Web Application is an invaluable tool for job seekers, students, and professionals aiming to create compelling resumes that stand out in today's competitive job market. Its user-centric design and powerful features make the resume-building process efficient and enjoyable.",
            "urlToImage": "https://drive.google.com/uc?id=1qC0BppKt60V3qXkSE4sL2BcJwqEW1XGx",
            "date": "2 Months Ago",
            "link": null
        },
        {
            "title": "Web Bank Application",
            "description": "The Java-based Bank Application is a comprehensive and secure digital platform designed to provide customers with seamless access to their financial needs. Built using Java technology, this application offers a robust and user-friendly interface for efficient banking operations.",
            "urlToImage": "https://drive.google.com/uc?id=1q-6JdT9X1seHpOtkEJNBcBiH4MrvEXW0",
            "date": "2 Months Ago",
            "link": null
        },
        {
            "title": "Web Reminder App",
            "description": "The Reminder App is a valuable companion for individuals with busy lives, students, professionals, and anyone seeking an efficient way to manage their tasks and responsibilities. Its thoughtful features and user-centric design make it an indispensable tool for maintaining a well-organized and balanced lifestyle.",
            "urlToImage": "https://drive.google.com/uc?id=1ftQSj0MP8OHPnyBfCG4pncRKfSKDOPBp",
            "date": "2 Months Ago",
            "link": null
        }
    ]
    return (
        <div className="container">
            <SubHeading heading="HTML , CSS , JS" color={props.color} />
            <div className="container my-3">
                <div className="row my-3 d-flex justify-content-center">
                    {webdev.map((element) => {
                        return <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 d-flex justify-content-center align-item-center my-3 border-0 rounded" key={element.urlToImage} data-aos-duration="1200" data-aos="fade-up" data-aos-delay="200">
                            <Card color={props.color} BGColor={props.BGColor} src={element.urlToImage} desc={element.description} title={element.title} date={element.date} link={element.link} imgheight={"200px"} height={"400px"} width={"25rem"} />
                        </div>
                    })}
                </div>
            </div>
            <SubHeading heading="Java Language" color={props.color} />
            <div className="container my-3">
                <div className="row my-3 d-flex align-item-center">
                    {javadev.map((element) => {
                        return <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 d-flex justify-content-center align-item-center my-3 border-0 rounded" key={element.urlToImage} data-aos-duration="1200" data-aos="fade-up" data-aos-delay="200">
                            <Card color={props.color} BGColor={props.BGColor} src={element.urlToImage} desc={element.description} title={element.title} date={element.date} link={element.link} imgheight={"200px"} height={"250px"} width={"25rem"} />
                        </div>
                    })}
                </div>
            </div >

        </div >
    )
}

export default Project
